import React, {FC} from 'react';
import css from "./TitleLogo.module.scss";
import logo from "../../../../../../assets/logo/logo.png"
import {observer} from "mobx-react";
import {languageToggleStore} from "../../../../../../features/LanguageToggle/model/languageToggleStore";
import HTMLReactParser from "html-react-parser";
import {instituteName} from "../../../../../../shared/enums/Data";


const TitleLogo: FC = observer(() => {
    const {activeLanguage} = languageToggleStore

    return (
        <div className={css.containerTitleLogo}>
            <img className={css.logo} src={logo} alt=""/>
            <div className={css.titleName}>
            {HTMLReactParser(activeLanguage === "ua" ? instituteName.ua : instituteName.eng)}
            </div>
        </div>
    );
});

export default TitleLogo;